import {
  AccountType,
  CustomFieldDataType,
  PWSCustomFieldEntity
} from '@120wateraudit/envirio-components/dist/models'
import { QueryResult, useQuery } from '@apollo/client'
import gql from 'graphql-tag'

import { useAccount } from 'src/router/UserProvider'
import {
  GET_CUSTOM_FIELDS,
  customFieldsClient
} from 'src/services/custom-fields-api'

export { default as CustomFieldDefinition } from './CustomFieldDefinition'

export const GET_CUSTOM_FIELD_DEFINITIONS = gql`
  query customFieldDefinitions(
    $accountId: Float!
    $entityName: String
    $accountType: Float!
  ) {
    customFieldDefinitions(
      accountId: $accountId
      entityName: $entityName
      accountType: $accountType
    ) {
      id
      name
      entityName
      dataType
      pickListValues
      valuesCount
      isExport
      isPickListMulti
    }
  }
`

export const useCustomFieldDefinitions = (entityName: PWSCustomFieldEntity) => {
  const { id } = useAccount()
  return useQuery(GET_CUSTOM_FIELD_DEFINITIONS, {
    client: customFieldsClient,
    variables: {
      accountId: id,
      accountType: AccountType.PWS,
      entityName
    }
  })
}

export interface CustomField {
  customFieldDefinitionId: number
  dataType: CustomFieldDataType
  entityId: number
  entityName: string
  fieldName: string
  isPickListMulti?: boolean
  pickListValues?: string[]
  value?: string
}

export const useCustomFields = (
  entityName: PWSCustomFieldEntity,
  entityId: number
): QueryResult<{ customFields: CustomField[] }> => {
  const { id } = useAccount()
  return useQuery(GET_CUSTOM_FIELDS, {
    client: customFieldsClient,
    variables: {
      accountId: id,
      criteria: {
        entities: [{ entityId, entityName }]
      }
    }
  })
}
